import { FaShareAlt } from "react-icons/fa";

const FlatListing = () => {
  return (
    <div className="flex items-center justify-between p-4 border rounded-lg ">
      <span className="text-gray-700 text-lg font-medium">
        2 BHK Flat For Sale in Elegant Param, in Gandhi Path, Jaipur
      </span>
      <div className="flex items-center space-x-4">
        <FaShareAlt className="text-gray-500 cursor-pointer hover:text-gray-700" size={20} />
        <button className="bg-red-500 text-white px-4 py-2 rounded-lg hover:bg-red-600">
          Contact Owner
        </button>
      </div>
    </div>
  );
};

export default FlatListing;
